module.exports = __webpack_public_path__ + "static/media/no_pockets.8a2c1897.svg";